export const data =
{
    teksti: ' "Vai kotihoidosta? Miten te nyt näin yllättäin tulitte? Ja miten te pääsitte sisään?", Pentti kysyy. Vastaat tähän, että ”ovi oli auki, oletin, että odottelitte meitä”. Pentti vaikuttaa aika loukkaantuneelta.',
    tarvittavaNoppaluku: 4,
    noppaMsg: "Heitä noppaa klikkaamalla nopan kuvaa. Pentti saattaa leppyä, jos saat silmäluvuksi vähintään ",
    optiot: []
};



